import QrScannerDialog from '@components/QrScannerDialog';

import { ActionComponentProps } from '../index';

type DialogQrCodeConfirmationProps = ActionComponentProps & {
  actionRequestInProgress: boolean;
  onQrCodeRecognized: (qrData: string) => void;
};

export const DialogQrCodeConfirmation = (props: DialogQrCodeConfirmationProps) => {
  const { actionStarted, actionRequestInProgress, onActionFinish, onQrCodeRecognized } = props;

  return (
    <QrScannerDialog
      open={actionStarted}
      title="Scan Recipient’s QR Code"
      loading={actionRequestInProgress}
      disableCloseButton={actionRequestInProgress}
      onClose={onActionFinish}
      onQrCodeRecognized={onQrCodeRecognized}
    />
  );
};
